<template>
  <component :is="layout" v-if="isInitialized">
    <router-view v-slot="{ Component }">
      <component :is="Component" v-if="Component" />
    </router-view>
  </component>
</template>

<script setup lang="ts">
import { useSidebarWatcher } from "shared/components/wrappers/drawer/useSidebarWatcher";
import { useGoogleAnalytics } from "shared/composables/useGoogleAnalytics";
import { useHelpScoutBeacon } from "shared/composables/useHelpScoutBeacon";
import { useMenuStore } from "store/modules/menuStore.js";
import { computed, onMounted, onUpdated, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

// Menu store
const menuStore = useMenuStore();
const {
  fetchUnreadNotificationsWithInterval,
  fetchUnfinishedTasksWithInterval,
} = menuStore;

// Router
const router = useRouter();
const route = useRoute();

// Drawer — sidebar query param → drawer rendering bridge
useSidebarWatcher();

// Analytics
const { initialize: initAnalytics } = useGoogleAnalytics();

// Help Scout Beacon (webmasters only)
const { initialize: initBeacon } = useHelpScoutBeacon();

// State
const isInitialized = ref(false);

const layout = computed<string>(
  () => (route?.meta?.layout as string) || "MainLayout",
);

const startNotificationPolling = (): void => {
  const token = localStorage.getItem("user_token");
  const schoolId = localStorage.getItem("school_id");
  const isAuthenticated = schoolId !== null && token !== null;

  if (isAuthenticated) {
    fetchUnreadNotificationsWithInterval();
    fetchUnfinishedTasksWithInterval();
  }
};

onUpdated(() => {
  startNotificationPolling();
});

onMounted(async () => {
  await router.isReady();

  initAnalytics(route);
  initBeacon();

  isInitialized.value = true;
});
</script>
